(function () {
  const path = window.location.pathname;

  const redirects = {
    "/collections/chewy-vuiton-1": "/collections/chewy-vuiton",
    "/collections/fursace-1": "/collections/fursace",
    "/collections/shop-all-1": "/collections/shop-all",
    "/collections/chewy-vuiton-copy": "/collections/chewy-vuiton"
  };

  if (redirects[path]) {
    window.location.href = redirects[path];
  }
})();